;(function () {
  'use strict'
  angular
    .module('contrast.compliance-policy')
    .controller('ConfigureCompliancePolicyCtrl', ConfigureCompliancePolicyCtrl)

  function ConfigureCompliancePolicyCtrl(
    $scope,
    $q,
    $routeParams,
    $location,
    RuleFactory,
    ApplicationService,
    UserService,
    ErrorService,
    compliancePolicyService,
    complianceReportService,
    APPLICATION_IMPORTANCE_LIST,
    RULE_SEVERITY_LIST,
    FILTER_GROUPS
  ) {
    'ngInject'

    var _allOptionValue = 'All'

    var policyId = $routeParams.compliancePolicyId
    var originalPolicy
    var applications = [],
      rules = [],
      complianceReports = []
    var allRules, allApplications

    angular.extend($scope, {
      isEdit: policyId ? true : false,
      saving: false,
      policy: {
        name: undefined,
        readonly: false,
        rules: [],
        applications: [],
        all_rules: true,
        all_applications: true
      },
      select: {
        rules: [],
        applications: []
      },
      loadPromise: undefined
    })

    angular.extend($scope, {
      launchDeleteDialog: launchDeleteDialog,
      onRulesUpdated: onRulesUpdated,
      onRulesDeleted: onRulesDeleted,
      onApplicationsUpdated: onApplicationsUpdated,
      onApplicationsDeleted: onApplicationsDeleted,
      validateForm: validateForm,
      execute: execute
    })

    function init() {
      var promises = []
      if (policyId) {
        $scope.policy.all_rules = false
        $scope.policy.all_applications = false
        promises.push(_getPolicy(policyId))
      }

      promises.push(_getRules())
      promises.push(_getApplications())
      promises.push(_getComplianceReports())

      $scope.loadPromise = $q.all(promises).then(function () {
        _populateRulesCombobox()
        _populateApplicationsCombobox()

        if (!policyId) {
          $scope.policy.rules.push(allRules)
          $scope.policy.applications.push(allApplications)
        } else {
          $scope.policy = compliancePolicyService.transformToPolicyView(
            originalPolicy,
            $scope.select.applications,
            $scope.select.rules
          )

          if ($scope.policy.all_rules) {
            $scope.policy.rules.push(allRules)
          }
          if ($scope.policy.all_applications) {
            $scope.policy.applications.push(allApplications)
          }
        }
      })
    }

    function launchDeleteDialog() {
      var policy = {
        policy_id: policyId,
        name: $scope.policy.name
      }
      return compliancePolicyService.confirmAndDelete(policy).then(function () {
        $location.path(UserService.buildUrl('/rules/compliance/policy'))
      })
    }

    function onRulesUpdated() {
      _updateMultiSelect($scope.policy.rules)
      $scope.policy.all_rules = false
    }

    function onRulesDeleted() {
      $scope.policy.all_rules = _deleteMultiSelect(
        $scope.policy.rules,
        allRules
      )
    }

    function onApplicationsUpdated() {
      _updateMultiSelect($scope.policy.applications)
      $scope.policy.all_applications = false
    }

    function onApplicationsDeleted() {
      $scope.policy.all_applications = _deleteMultiSelect(
        $scope.policy.applications,
        allApplications
      )
    }

    function validateForm() {
      if (
        $scope.policy.name === '' ||
        $scope.policy.rules.length == 0 ||
        $scope.policy.applications.length == 0
      ) {
        return false
      }

      return true
    }

    function execute() {
      $scope.saving = true

      var data = compliancePolicyService.createRequest($scope.policy)
      var request

      if (!$scope.isEdit) {
        request = compliancePolicyService.createPolicy(data)
      } else {
        request = compliancePolicyService.updatePolicy(policyId, data)
      }

      request
        .then(function () {
          $location.path(UserService.buildUrl('/rules/compliance/policy'))
        })
        .finally(function () {
          $scope.saving = false
        })
    }

    function _getPolicy(policyId) {
      return compliancePolicyService
        .getPolicy(policyId)
        .then(function (policy) {
          originalPolicy = policy
        })
    }

    function _getRules() {
      return RuleFactory.getRulesBase()
        .then(function (response) {
          rules = response.data.rules
          allRules = {
            name: 'All Rules (' + rules.length + ')',
            value: _allOptionValue
          }
        })
        .catch(ErrorService.processError)
    }

    function _getApplications() {
      return ApplicationService.getApplicationBase(false).then(function (apps) {
        applications = apps
        allApplications = {
          name: 'All Applications (' + applications.length + ')',
          value: _allOptionValue
        }
      })
    }

    function _getComplianceReports() {
      return complianceReportService.getReports().then(function (reports) {
        _.each(reports, function (report) {
          complianceReports.push({
            value: report.name,
            name: report.short_name
          })
        })
      })
    }

    function _populateRulesCombobox() {
      var severities = angular.copy(RULE_SEVERITY_LIST)
      _.each(severities, function (element) {
        _.extend(element, { group: FILTER_GROUPS.SEVERITY })
      })
      $scope.select.rules = severities

      var reports = angular.copy(complianceReports)
      _.each(reports, function (complianceReport) {
        _.extend(complianceReport, { group: FILTER_GROUPS.SECURITY_STANDARDS })
      })

      $scope.select.rules = $scope.select.rules.concat(_.values(reports))

      var i = 0
      var rule
      for (; i < rules.length; i++) {
        rule = rules[i]
        $scope.select.rules.push({
          name: rule.title,
          value: rule.name,
          group: FILTER_GROUPS.VULNERABILITY_RULES
        })
      }
    }

    function _populateApplicationsCombobox() {
      var importance = angular.copy(APPLICATION_IMPORTANCE_LIST)
      _.each(importance, function (element) {
        _.extend(element, { group: FILTER_GROUPS.IMPORTANCE })
      })
      $scope.select.applications = importance

      var i = 0
      var app
      for (; i < applications.length; i++) {
        app = applications[i]
        $scope.select.applications.push({
          name: app.name,
          value: app.app_id,
          group: FILTER_GROUPS.APPLICATIONS
        })
      }
    }

    /**
     * Helper methods
     */
    function _updateMultiSelect(array) {
      var index = _.findIndex(array, function (item) {
        return item.value === _allOptionValue
      })

      if (index != -1) {
        array.splice(index, 1)
      }
    }

    function _deleteMultiSelect(array, allOption) {
      if (array.length == 0) {
        array.push(allOption)
        return true
      } else {
        return false
      }
    }

    init()
  }
})()
